"use client";

import React, { useRef } from "react";
import { usePageParams } from "../../../hooks/usePageParams";
import { AutoSuggest } from "../../AutoSuggest";
import { Favorites } from "../../Favorites/mobile";
import { WebsiteLogo } from "../../WebsiteLogo";
import { useHeaderScroll } from "../hooks";
import styles from "./styles.module.scss";
import { TopLocations } from "./topLocations";

export const Header: React.FC = () => {
    const innerTopRef = useRef<HTMLDivElement>(null);
    useHeaderScroll({ ref: innerTopRef, styles });
    const { pageType } = usePageParams();

    return (
        <header className={styles.header}>
            <div className={styles.firstRow} ref={innerTopRef}>
                <div className={styles.firstRowLogo}>
                    <WebsiteLogo />
                </div>
                <div className={styles.firstRowAutoSuggest}>
                    <AutoSuggest />
                </div>
            </div>
            <div className={styles.secondRow}>
                {pageType?.isHomePage ? <Favorites /> : null}
                <TopLocations />
            </div>
        </header>
    );
};
